export const faqs = [
  {
    q: '18爆料网的内容是每天更新的吗？',
    a: '是。编辑组会按"今日爆料"的节奏持续整理公开信息与网友投稿，通常在白天与晚间两个时段集中更新，热点事件会随时补更。',
  },
  {
    q: '网站上的爆料信息都可靠吗？',
    a: '我们会区分"已确认"与"尚在传闻"两类信息：前者来自公开声明、官方回应或可核实的公开资料；后者会明确标注为讨论中，并尽量呈现多方说法。同时也欢迎读者对不准确的内容进行反馈。',
  },
  {
    q: '普通网友可以投稿吗？',
    a: '可以。素人投稿栏目长期面向所有读者开放，欢迎分享生活里的真实经历。投稿请尽量说明时间、地点与背景，我们会与投稿人二次确认后再决定是否发布。',
  },
  {
    q: '为什么不写具体的爆料对象？',
    a: '为了避免对无关的真人造成影响，我们在处理投稿与匿名爆料时，会隐去或模糊与事件无关的个人信息，只保留理解事件所必需的背景。',
  },
  {
    q: '网站是免费的还是需要注册？',
    a: '浏览全部内容无需注册，也不需要付费。我们不会要求读者提供手机号等敏感信息，遇到此类要求请提高警惕。',
  },
  {
    q: '发现内容有误或想联系编辑组怎么办？',
    a: '可以通过"关于我们"页面上的联系方式与编辑组取得联系。涉及内容更正、侵权投诉或合作事宜，请注明来意，我们会尽快回复。',
  },
];